import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/icon/index.vue";
import {
  COMPANY_INFO,
  ADVANTAGE_LIST,
  OTHER_LINKS_GROUP,
  QR_CODES,
} from "../config";

export default /*#__PURE__*/_defineComponent({
  __name: 'common-footer',
  setup(__props) {

const guohuiIcon = require("../assets/imgs/guohui.png");
const logoImg = require("../assets/imgs/logo.png");

return { __sfc: true,guohuiIcon, logoImg, Icon, COMPANY_INFO, ADVANTAGE_LIST, OTHER_LINKS_GROUP, QR_CODES }
}

})